var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 26,
    viewBox: "0 0 30 26",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 5H24.5",
    stroke: "current",
    strokeWidth: 2,
    strokeMiterlimit: 9.59865,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 13H24.5",
    stroke: "current",
    strokeWidth: 2,
    strokeMiterlimit: 9.59865,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 21H24.5",
    stroke: "current",
    strokeWidth: 2,
    strokeMiterlimit: 9.59865,
    strokeLinecap: "round"
  })));
};
export default __webpack_public_path__ + "static/media/menu.3afe0c91.svg";
export { SvgComponent as ReactComponent };